import Vue from 'vue';
import Vuex from 'vuex';
import LoginStore from '@/store/LoginStore/LoginStore';
import findStore from '@/store/finderStore/finderStore';
import UserStore from '@/store/UserStore/UserStore';
import DashboardLayoutStore from '@/store/DashboardLayoutStore/DashboardLayoutStore';
import UserListStore from '@/store/UserListStore/UserListStore';
import DonorListStore from '@/store/DonorListStore/DonorListStore';
import DonorCreateStore from '@/store/DonorCreateStore/DonorCreateStore';
import RequestStore from '@/store/RequestStore/RequestStore';
import RequestFeedStore from '@/store/RequestStore/RequestFeedStore';
import MyDonationListStore from '@/store/MyDonationListStore/MyDonationListStore';
import BloodGroupStore from '@/store/GenericStore/BloodGroupStore';
import DonorUpdateStore from '@/store/DonorCreateStore/DonorUpdateStore';
import GenderStore from '@/store/GenericStore/GenderStore';
import LandingStore from '@/store/LandingStore/LandingStore';
import FeedBackListStore from '@/store/FeedBackStore/FeedBackListStore';

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules:{
    findStore,
    LoginStore,
    UserStore,
    DashboardLayoutStore,
    UserListStore,
    DonorListStore,
    DonorCreateStore,
    RequestStore,
    RequestFeedStore,
    MyDonationListStore,
    BloodGroupStore,
    DonorUpdateStore,
    GenderStore,
    LandingStore,
    FeedBackListStore
  }
});
